export class CpfHelper {
  static format(value: string | null | undefined): string {
    if (!value) return '';

    let v = value.replace(/\D/g, '');

    if (v.length > 11) {
      v = v.substring(0, 11);
    }

    if (v.length > 9) {
      return `${v.substring(0, 3)}.${v.substring(3, 6)}.${v.substring(6, 9)}-${v.substring(9)}`;
    }

    if (v.length > 6) {
      return `${v.substring(0, 3)}.${v.substring(3, 6)}.${v.substring(6)}`;
    }

    if (v.length > 3) {
      return `${v.substring(0, 3)}.${v.substring(3)}`;
    }

    return v;
  }

  static clean(value: string | null | undefined): string {
    return value?.replace(/\D/g, '') ?? '';
  }
}
